import moment from "moment";
import { ValueOrDots } from "../../../components/exportWord/partials";
import { formatDateTable } from "../../../utils/functionUtils";

const TemplateBaoCaoCaNhan = (props: any) => {
  const { data } = props;

  return (
    <div className="word spaces px-70 colors-word print-page-break ">
      <div className="spaces text-center flex flex-between">
        <div>
          <p className="fw-600">
            <span className="spaces text-uppercase ml-5">
              <ValueOrDots className="" value={data?.departmentOfHealth || ""} size={70} />
            </span>
          </p>
          <p className="fw-600">
            <span className="spaces text-uppercase ml-5">
              <ValueOrDots className="" value={data?.orgHeader || ""} size={70} />
            </span>
          </p>
        </div>
        <div></div>
      </div>
      <div className="text-center">
        <p className="text-uppercase fw-600">BẢNG TỔNG HỢP THEO DÕI ĐÀO TẠO LIÊN TỤC</p>
        <p className="fw-600">
          Năm: <ValueOrDots size={10} value={moment().format("YYYY") || ""} />
        </p>
      </div>
      <div className="spaces mt-16 ml-100">
        <p>
          <span><b>Họ và tên: </b></span>
          <ValueOrDots value={data?.tenNhanVien || ""} />
        </p>
        <p>
          <span><b>Khoa/Phòng: </b></span>
          <ValueOrDots value={data?.phongBanText || ""} />
        </p>
        <p>
          <span><b>Trình độ chuyên môn: </b></span>
          <ValueOrDots value={data?.chucDanhText || ""} />
        </p>
      </div>

      <div className="spaces mt-16 mb-100">
        <table className="table-auto border border-collapse border-gray-600 w-100 text-center">
          <thead>
            <tr>
              <th className="border border-gray-600 fs-6 px-2">STT</th>
              <th className="border border-gray-600 fs-6 px-2">NỘI DUNG ĐÀO TẠO LIÊN TỤC</th>
              <th className="border border-gray-600 fs-6 px-2" style={{ width: "150px" }}>NƠI ĐÀO TẠO</th>
              <th className="border border-gray-600 fs-6 px-2" style={{ width: "180px" }}>THỜI GIAN ĐÀO TẠO</th>
              <th className="border border-gray-600 fs-6 px-2" style={{ width: "150px" }}>TỔNG SỐ TIẾT QUY ĐỔI</th>
            </tr>
          </thead>
          <tbody>
            {data.khoaHocDtos && data.khoaHocDtos.map((row: any, index: number) => (
              <tr key={row?.id}>
                <td className="border border-gray-600 fs-6 px-2">{index + 1}</td>
                <td className="border border-gray-600 text-left fs-6 px-2">{row?.tenKhoaDaoTao ?? ""}</td>
                <td className="border border-gray-600 text-left fs-6 px-2">{row?.noiDaoTao ?? ""}</td>
                <td className="border border-gray-600 text-left fs-6 px-2">{formatDateTable(row?.hieuLucTuNgay)} {row?.hieuLucDenNgay && " - "}{formatDateTable(row?.hieuLucDenNgay)}</td>
                <td className="border border-gray-600 fs-6 px-2">{row?.soTiet ?? ""}</td>
              </tr>
            ))}
            {[...Array(2)].map((_, i) => (
              <tr key={i}>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
              </tr>
            ))}
            <tr>
              <td className="border border-gray-600">&nbsp;</td>
              <td className="border border-gray-600 text-left spaces pl-10 fw-600 fs-14" colSpan={3}>TỔNG SỐ TIẾT QUY ĐỔI</td>
              <td className="border border-gray-600 fw-600">{data.tongSoTietQuyDoi || 0}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TemplateBaoCaoCaNhan;